module.exports = __webpack_public_path__ + "img/info.df836f3a.svg";